
import { Component, Vue } from 'vue-property-decorator';

import AppHeader from '@/shared/components/AppHeader.vue';
import LeftMenu from '@/shared/components/LeftMenu.vue';
import Breadcrumb from '@/shared/components/Breadcrumb.vue';

import authService from '@/services/auth-services';
import commonServices from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';

import AppEvents from '@/event.js';
import { eventBus } from '@/main';

@Component({
  components: {
    AppHeader,
    LeftMenu,
    'bread-crumb': Breadcrumb
  },
})
export default class App extends Vue {
  disableMenuLeft = true;
  disableHeader = true;
  showNotificationPopup = false;
  notificationContent = '';

  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }

  get rate() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
  }

  private beforeCreate() {
    AppEvents.forEach((item) => {
        this.$on(item.name, item.callback);
      });
    window['getApp'] = this;
  }

  private async created() {
    eventBus.$on(APP_CONFIG.eventBusAction.disableMenuLeft, (data) => {
      this.disableMenuLeft = data;
    });

    eventBus.$on(APP_CONFIG.eventBusAction.disableHeader, (data) => {
      this.disableHeader = data;
    });

    // Load configuration and show notification if needed
    await this.loadConfiguration();

    if (!this.rate) {
      await this.getRate();
    }
  }

  private async getRate() {
    const result = await commonServices.exchangeRate();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
    }
  }

  private async loadConfiguration() {
    try {
      // Check if notification is hidden for 24h
      const hideUntil = localStorage.getItem('notification_hide_until');
      if (hideUntil) {
        const hideUntilTime = parseInt(hideUntil, 10);
        const now = new Date().getTime();
        if (now < hideUntilTime) {
          // Still within hide period, don't show popup
          return;
        } else {
          // Hide period expired, remove from localStorage
          localStorage.removeItem('notification_hide_until');
        }
      }

      const result: any = await commonServices.configuration();
      if (result && result.data && result.data.status === 200 && result.data.data) {
        const config = result.data.data;
        if (config.ShowNotification === 1 && config.NoteForCustomer) {
          this.notificationContent = config.NoteForCustomer;
          this.showNotificationPopup = true;
        }
      }
    } catch (error) {
      // console.error('Error loading configuration:', error);
    }
  }

  private closeNotificationPopup() {
    this.showNotificationPopup = false;
  }

  private hideFor24Hours() {
    // Set hide until timestamp (24 hours from now)
    const now = new Date().getTime();
    const hideUntil = now + (24 * 60 * 60 * 1000); // 24 hours in milliseconds
    localStorage.setItem('notification_hide_until', hideUntil.toString());
    this.showNotificationPopup = false;
  }

  private onClickMask() {
    (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
  }
}
